import { AppQueryProvider } from "@/components/query-provider";
import { ThemeProvider } from "@/components/theme-provider";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/auth-context";
import { OrgProvider } from "@/contexts/org-context";
import { PortalProvider } from "@/contexts/portal-context";
import { getPortalSlug } from "@/lib/portal";
import { vaultAppUrl } from "@/lib/vault-app";
import { Outlet, redirect, rootRouteWithContext } from "@tanstack/react-router";

interface RouterContext {}

// On a branded portal host, only the vault client experience is reachable.
// Paths outside this allowlist (advisor app, org settings, marketing) redirect to login.
const PORTAL_ALLOWED_PREFIXES = ["/vault", "/auth"];

export const Route = rootRouteWithContext<RouterContext>()({
  beforeLoad: ({ location }) => {
    if (getPortalSlug() === null) return;
    const path = location.pathname;
    const allowed = PORTAL_ALLOWED_PREFIXES.some(
      (p) => path === p || path.startsWith(`${p}/`)
    );
    if (!allowed) {
      throw redirect({ href: vaultAppUrl("/") });
    }
  },
  component: () => (
    <PortalProvider>
      <AuthProvider>
        <OrgProvider>
          <AppQueryProvider>
            <ThemeProvider
              attribute="class"
              defaultTheme="system"
              enableSystem
              disableTransitionOnChange
            >
              <Outlet />
              <Toaster />
            </ThemeProvider>
          </AppQueryProvider>
        </OrgProvider>
      </AuthProvider>
    </PortalProvider>
  ),
});
